import { render, staticRenderFns } from "./PersonProfile.vue?vue&type=template&id=235972f8&scoped=true&"
import script from "./PersonProfile.vue?vue&type=script&lang=js&"
export * from "./PersonProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235972f8",
  null
  
)

export default component.exports